import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import PhoneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity";
import { ICreateBusinessPartnerPhone } from "./interfaces/create-business-partner-phone.interface";
import { IUpdateBusinessPartnerPhone } from "./interfaces/update-business-partner-phone.interface";
const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business_partner_phone";

@Injectable({
  providedIn: "root",
})
export class BusinessPartnerPhoneService extends AbstractService<
PhoneAttributes,
ICreateBusinessPartnerPhone,
IUpdateBusinessPartnerPhone
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByBusinessId(businessId: string): Observable<IResult<PhoneAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${businessId}`;
    return this.http.get<IResult<PhoneAttributes>>(API_URL);
  }
}